import {
  BlocklistInformationFormFields,
  type BlocklistInformationFormFieldsProps,
  type PersonalInformationReadOnlyFieldsProps,
} from '@exam-center/blocked-user-management';
import {
  Divider,
  Flex,
  Form,
  FormButton,
  type FormProps,
  PaperSection,
  SectionTitle,
} from '@shared/components';

import {
  EmployeeInformationReadonlyFields,
  type EmployeeInformationReadonlyFieldsProps,
} from '../employee-information-readonly-fields';

export type BlockedRecordProctorFormProps = Omit<
  Extract<BlocklistInformationFormFieldsProps, { mode: 'edit' }>,
  'mode'
> & {
  fields: PersonalInformationReadOnlyFieldsProps & EmployeeInformationReadonlyFieldsProps;
  submitting: boolean;
} & FormProps;

export default function BlockedRecordProctorForm(props: Readonly<BlockedRecordProctorFormProps>) {
  const { fields, submitting: isSubmitting, ...restProps } = props;

  return (
    <Form {...restProps}>
      <Flex sx={(theme) => ({ flexDirection: 'column', gap: theme.spacing(6) })}>
        <PaperSection title='ข้อมูลการระงับสิทธิ์สอบ'>
          <Flex
            sx={(theme) => ({
              flexDirection: 'column',
              gap: theme.spacing(6),
              p: theme.spacing(6),
            })}
          >
            <SectionTitle title='Person Information' />
            <EmployeeInformationReadonlyFields
              blockedType={fields.blockedType}
              position={fields.position}
              department={fields.department}
            />
            <Divider />
            <SectionTitle title='Blocklist Information' />
            <BlocklistInformationFormFields
              mode='edit'
              fields={{
                blockedAt: fields.blockedAt,
                blockedUntil: fields.blockedUntil,
                enforcementDate: fields.enforcementDate,
                blockedCourse: fields.blockedCourse,
                reason: fields.reason,
              }}
            />
          </Flex>
        </PaperSection>
        <Flex sx={(theme) => ({ flex: 1, justifyContent: 'flex-end', gap: theme.spacing(3) })}>
          <FormButton label='บันทึก' size='large' loading={isSubmitting} />
        </Flex>
      </Flex>
    </Form>
  );
}
